import { CircleCheckBig, Undo2 } from 'lucide-react';
import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import MenuAction from '~/components/Menu/MenuAction';
import { DICOMApprovalStatus } from '~/domain/dicom/dicomConstants';

/** The approval statuses the user can move a structure set to. */
const STRUCTURE_SET_APPROVAL_ACTIONS = [
    {
        status: DICOMApprovalStatus.APPROVED,
        labelId: 'datasetPicker.approveAll',
        Icon: CircleCheckBig,
        testId: 'approve-all-structureset-button',
    },
    {
        status: DICOMApprovalStatus.UNAPPROVED,
        labelId: 'datasetPicker.unapprove',
        Icon: Undo2,
        testId: 'unapprove-structureset-button',
    },
] as const;

/**
 * The menu rows that move `structureSet` to another approval status: one
 * for each status it is not in. A rejected set offers both; none offers
 * Reject. Choosing a row hands its request to `onPick`. The rows are keyed
 * and go directly into a menu, so the menu's keyboard navigation reaches
 * them.
 */
export function structureSetApprovalMenuItems(
    structureSet: { dicomUid: string; approvalStatus: DICOMApprovalStatus },
    onPick: (request: {
        sopUid: string;
        newApprovalStatus: DICOMApprovalStatus;
    }) => void
): ReactNode[] {
    return STRUCTURE_SET_APPROVAL_ACTIONS.filter(
        (action) => action.status !== structureSet.approvalStatus
    ).map((action) => (
        <MenuAction
            key={action.status}
            icon={<action.Icon />}
            label={<FormattedMessage id={action.labelId} />}
            onClick={() =>
                onPick({
                    sopUid: structureSet.dicomUid,
                    newApprovalStatus: action.status,
                })
            }
            data-testid={action.testId}
        />
    ));
}
